enum RRCThicknessAlgorithm {
    FirstArrival = 1,
    PeakToPeak = 2,
    FirstArrivalThicknessLoss = 3
}

export default RRCThicknessAlgorithm;
